import {SET_LOADING} from './loadingTypes';

export function loadingModal(isOpen) {
   return {
      type: SET_LOADING,
      payload: isOpen
   };
}
